import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { EntityBatchField } from '@shared/data/entity/fields/EntityBatchField';
import { CollectionViewFieldContainer } from './CollectionViewFieldContainer';
import { FieldVariant } from './FieldVariant';
import classNames from './EntityBatchCollectionViewField.module.css';

interface Props {
  variant: FieldVariant;
  className?: ClassValue;
  field: EntityBatchField;
}

/** Default and compact: the schedule's name. Inline: the name as text. */
export function EntityBatchCollectionViewField({ field, variant, className }: Props) {
  const schedule = field.refs.find(ref => ref.id === field.id);
  if (isNil(schedule)) {
    return null;
  }

  return (
    <CollectionViewFieldContainer
      fieldType={field.fieldType}
      variant={variant}
      className={className}
    >
      {variant === 'inline' && schedule.name}
      {variant !== 'inline' && (
        <View className={classNames.container}>
          <Text size="body1" className={classNames.text}>
            {schedule.name}
          </Text>
        </View>
      )}
    </CollectionViewFieldContainer>
  );
}
